import React, { useState, useEffect, useRef } from 'react';
import './AssetDiscovery.css';
import starIcon from '../../assets/images/star.svg';
import AssetDiscoveryImg from '../../assets/images/fra2.svg';

const AssetDiscovery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Stop observing after animation triggers
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3, // Trigger when 30% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before element is fully in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="discovery-section" ref={sectionRef}>
      <div className="discovery-content">
        <div className="discovery-visual-content">
          <img 
            src={AssetDiscoveryImg} 
            alt="Asset Discovery interface" 
            className={`discovery-main-img ${isVisible ? 'animate-slide-left delay-300' : ''}`} 
          />
        </div>

        <div className="discovery-text-content">
          
          <h2>
            <span className={`discovery-intuitive-text ${isVisible ? 'animate-slide-right delay-300' : ''}`}>Enhanced Asset</span>
            <span className={`discovery-organisation-text ${isVisible ? 'animate-slide-right delay-500' : ''}`}>Discovery</span>
          </h2>
          <p className={`${isVisible ? 'animate-slide-right delay-700' : ''}`}>
            <span className="discovery-first-line">Find exactly what you need with smart search, predictive tags, and filters that learn from usage patterns.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default AssetDiscovery;
